var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
import { __awaiter, __decorate, __metadata } from "tslib";
import { Mutation, Action, VuexModule, Module } from 'vuex-module-decorators';
import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/finance/DepartmentEnums';
let DepartmentModule = class DepartmentModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.wasFirstLoad = true;
        this.loading = false;
        this.loadPage = false;
        this.departmentList = [];
        this.page = 1;
        this.size = 10;
        this.pageFilter = 1;
        this.wasLoadQuickFilter = true;
        this.desc = '';
        this.searchBy = '';
        this.paging = [];
        this.status = '';
        this.statusMessage = '';
        this.selectedDepartmentName = [];
        this.dropdownlistDepartmentCode = [];
        this.dropdownlistDepartmentName = [];
    }
    get getDepartmentWasFirstLoad() {
        return this.wasFirstLoad;
    }
    get getDropdownlistDepartmentCode() {
        return this.dropdownlistDepartmentCode;
    }
    get getDropdownlistDepartmentName() {
        return this.dropdownlistDepartmentName;
    }
    get getDepartmentLists() {
        return this.departmentList;
    }
    get getDepartmentStatus() {
        const status = {
            status: this.status,
            statusMessage: this.statusMessage
        };
        return status;
    }
    get getSelectedDepartmentName() {
        return this.selectedDepartmentName;
    }
    get getDepartmentPaging() {
        return this.paging;
    }
    get getDepartmentLoading() {
        return this.loading;
    }
    get getStatusDepartment() {
        const status = {
            status: this.status,
            statusMessage: this.statusMessage
        };
        return status;
    }
    get getDepartmentSize() {
        return this.size;
    }
    get getDepartmentWasLoadQuickFilter() {
        return this.wasLoadQuickFilter;
    }
    get getDepartmentDesc() {
        return this.desc;
    }
    get getDepartmentSearchBy() {
        return this.searchBy;
    }
    [_a = Mutations.SET_DEPARTMENT_LOAD](payload) {
        this.wasFirstLoad = payload;
    }
    [_b = Mutations.SET_SELECTED_DEPARTMENT_NAME](payload) {
        this.selectedDepartmentName = payload;
    }
    [_c = Mutations.SET_DEPARTMENT_LIST](payload) {
        this.departmentList = payload;
    }
    [_d = Mutations.SET_DEPARTMENT_LOADING](payload) {
        this.loading = payload;
    }
    [_e = Mutations.SET_DEPARTMENT_HANDLE_PAGE](payload) {
        this.page = payload;
    }
    [_f = Mutations.SET_DEPARTMENT_PAGE](payload) {
        this.paging = payload;
    }
    [_g = Mutations.SET_DEPARTMENT_LOAD_PAGE]() {
        this.loadPage = true;
    }
    [_h = Mutations.SET_DEPARTMENT_STATUS](payload) {
        this.status = payload.statusAssetNumber;
        this.statusMessage = payload.statusMessageAssetNumber;
    }
    [_j = Mutations.SET_DROPDOWNLIST_DEPARTMENT_CODE](payload) {
        this.dropdownlistDepartmentCode = payload;
    }
    [_k = Mutations.SET_DROPDOWNLIST_DEPARTMENT_NAME](payload) {
        this.dropdownlistDepartmentName = payload;
    }
    [_l = Mutations.SET_DEPARTMENT_SIZE](payload) {
        this.size = payload;
    }
    [_m = Mutations.SET_DEPARTMENT_HANDLE_SIZE](payload) {
        this.size = payload;
    }
    [_o = Mutations.SET_DEPARTMENT_PAGE_FILTER](payload) {
        this.pageFilter = payload;
    }
    [_p = Mutations.SET_DEPARTMENT_WAS_LOAD_QUICK_FILTER](payload) {
        this.wasLoadQuickFilter = payload;
    }
    [_q = Mutations.SET_DEPARTMENT_DESC](payload) {
        this.desc = payload;
    }
    [_r = Mutations.SET_DEPARTMENT_SEARCH_BY](payload) {
        this.searchBy = payload;
    }
    [_s = Actions.GET_DEPARTMENT_LIST]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_DEPARTMENT_LOADING, false);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/department/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.page.toString(),
                Size: this.size.toString(),
                departmentName: this.selectedDepartmentName,
                isActive: true
            };
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    var _y, _z;
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_DEPARTMENT_LIST, ((_y = res.data.result.content) === null || _y === void 0 ? void 0 : _y.data) || []);
                        this.context.commit(Mutations.SET_DEPARTMENT_LOAD_PAGE, true);
                        this.context.commit(Mutations.SET_DEPARTMENT_PAGE, ((_z = res.data.result.content) === null || _z === void 0 ? void 0 : _z.paging) || {
                            currentPage: 0,
                            totalPages: 0,
                            totalElements: 0,
                            errorRows: 0,
                            readyToUpload: 0
                        });
                        this.context.commit(Mutations.SET_DEPARTMENT_LOADING, false);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_DEPARTMENT_LOADING, false);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    reject(false);
                });
            });
        });
    }
    [_t = Actions.GET_DEPARTMENT_LIST_ALLDATA]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_DEPARTMENT_WAS_LOAD_QUICK_FILTER, false);
            const params = {
                ver: 'v1'
            };
            const dataListDepartmentCode = [...this.dropdownlistDepartmentCode];
            const dataListDepartmentName = [...this.dropdownlistDepartmentName];
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/department/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.pageFilter.toString(),
                Size: '10',
                Desc: this.desc,
                SearchBy: this.searchBy,
                isActive: true
            };
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    if (res.status === 200) {
                        if (res.data.result.content !== null) {
                            if (res.data.result.content.paging.totalPages === this.pageFilter) {
                                this.context.commit(Mutations.SET_DEPARTMENT_WAS_LOAD_QUICK_FILTER, false);
                            }
                            else {
                                this.context.commit(Mutations.SET_DEPARTMENT_WAS_LOAD_QUICK_FILTER, true);
                            }
                            res.data.result.content.data.map((data) => {
                                dataListDepartmentCode.push({
                                    value: data.departmentCode,
                                    label: data.departmentCode
                                });
                                dataListDepartmentName.push({
                                    value: data.departmentName,
                                    label: data.departmentName
                                });
                            });
                        }
                        else {
                            this.context.commit(Mutations.SET_DEPARTMENT_WAS_LOAD_QUICK_FILTER, false);
                        }
                        this.context.commit(Mutations.SET_DROPDOWNLIST_DEPARTMENT_CODE, dataListDepartmentCode);
                        this.context.commit(Mutations.SET_DROPDOWNLIST_DEPARTMENT_NAME, dataListDepartmentName);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_DEPARTMENT_WAS_LOAD_QUICK_FILTER, false);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    this.context.commit(Mutations.SET_DEPARTMENT_WAS_LOAD_QUICK_FILTER, false);
                    reject(false);
                });
            });
        });
    }
    [_u = Actions.UPDATE_DEPARTMENT_SIZE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_DEPARTMENT_SIZE, data);
            this.context.commit(Mutations.SET_DEPARTMENT_HANDLE_PAGE, 1);
            this.context.dispatch(Actions.GET_DEPARTMENT_LIST);
        });
    }
    [_v = Actions.UPDATE_DEPARTMENT_PAGE_FILTER]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_DEPARTMENT_PAGE_FILTER, this.pageFilter + 1);
        });
    }
    [_w = Actions.UPDATE_DEPARTMENT_CODE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_DEPARTMENT_SEARCH_BY, data === '' ? '' : 'departmentcode');
            this.context.commit(Mutations.SET_DEPARTMENT_DESC, data);
            this.context.commit(Mutations.SET_DROPDOWNLIST_DEPARTMENT_CODE, []);
            this.context.commit(Mutations.SET_DROPDOWNLIST_DEPARTMENT_NAME, []);
            this.context.commit(Mutations.SET_DEPARTMENT_PAGE_FILTER, 1);
            this.context.dispatch(Actions.GET_DEPARTMENT_LIST_ALLDATA);
        });
    }
    [_x = Actions.UPDATE_DEPARTMENT_DESC](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_DEPARTMENT_SEARCH_BY, data === '' ? '' : 'departmentname');
            this.context.commit(Mutations.SET_DEPARTMENT_DESC, data);
            this.context.commit(Mutations.SET_DROPDOWNLIST_DEPARTMENT_CODE, []);
            this.context.commit(Mutations.SET_DROPDOWNLIST_DEPARTMENT_NAME, []);
            this.context.commit(Mutations.SET_DEPARTMENT_PAGE_FILTER, 1);
            this.context.dispatch(Actions.GET_DEPARTMENT_LIST_ALLDATA);
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DepartmentModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DepartmentModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DepartmentModule.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DepartmentModule.prototype, _d, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DepartmentModule.prototype, _e, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DepartmentModule.prototype, _f, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DepartmentModule.prototype, _g, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DepartmentModule.prototype, _h, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DepartmentModule.prototype, _j, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DepartmentModule.prototype, _k, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DepartmentModule.prototype, _l, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DepartmentModule.prototype, _m, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DepartmentModule.prototype, _o, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DepartmentModule.prototype, _p, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DepartmentModule.prototype, _q, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DepartmentModule.prototype, _r, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], DepartmentModule.prototype, _s, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], DepartmentModule.prototype, _t, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], DepartmentModule.prototype, _u, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], DepartmentModule.prototype, _v, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], DepartmentModule.prototype, _w, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], DepartmentModule.prototype, _x, null);
DepartmentModule = __decorate([
    Module
], DepartmentModule);
export default DepartmentModule;
